import { Input } from '@components/core-ui/form-elements/Input';
import EyeIcon from '@components/icons/Eye.svg';
import EyeClosedIcon from '@components/icons/EyeClosed.svg';
import { cn } from '@helpers/cn';
import { forwardRef, useId } from 'react';
import { TProps } from './types/TProps';

export const PasswordField = forwardRef<HTMLInputElement, TProps>(function PasswordField(
  {
    name,
    label,
    value,
    onChange,
    onBlur,
    isVisible,
    onVisibilityToggle,
    hint,
    error,
    autoComplete,
    required = false,
    disabled = false,
    className,
  },
  ref,
) {
  const messageId = useId();
  const message = error || hint;

  return (
    <div className={className}>
      <Input
        ref={ref}
        name={name}
        label={label}
        type={isVisible ? 'text' : 'password'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        handleBlur={() => onBlur?.()}
        onIconClick={onVisibilityToggle}
        iconButtonLabel={isVisible ? 'Hide password' : 'Show password'}
        icon={isVisible ? EyeIcon : EyeClosedIcon}
        error={Boolean(error)}
        aria-describedby={message ? messageId : undefined}
        autoComplete={autoComplete}
        required={required}
        disabled={disabled}
      />
      {message ? (
        <p id={messageId} className={cn('mt-2 text-left text-xs text-foreground-muted', error && 'text-error')}>
          {message}
        </p>
      ) : null}
    </div>
  );
});

PasswordField.displayName = 'PasswordField';
